import * as Sentry from "@sentry/react";
import { showErrorToast } from "@/services/toastService";

const handleBoundaryError = (error, errorInfo) => {
  console.error("[AppErrorBoundary] React error boundary:", error, errorInfo);
  showErrorToast(error, { componentStack: errorInfo?.componentStack });
};

const FallbackComponent = () => (
  <div className="flex min-h-screen flex-col items-center justify-center p-4 text-center">
    <h1 className="mb-4 text-3xl font-bold text-red-600">
      An Application Error Occurred
    </h1>
    <p className="mb-6 text-gray-700">
      We've been notified and are looking into it. Please reload the page to
      continue.
    </p>
    <button
      onClick={() => window.location.reload()}
      className="rounded-lg bg-blue-600 px-6 py-2 font-semibold text-white transition-colors hover:bg-blue-700"
    >
      Reload Page
    </button>
  </div>
);

export const AppErrorBoundary = ({ children }) => (
  <Sentry.ErrorBoundary
    fallback={<FallbackComponent />}
    onError={handleBoundaryError}
  >
    {children}
  </Sentry.ErrorBoundary>
);

export default AppErrorBoundary;
